<template>
  <product-variant-selection-elevate
    v-if="product"
    v-model="attributeSelection"
    v-model:form-ref="attributeSelectionFormRef"
    as-form
    :attribute-selection-labels="attributeSelectionLabels"
    :error
    :handle-next-attribute="handleNextAttribute"
    :inventory
    :is-coming-soon="isComingSoon"
    :pending
    :product
    :selected-variant="selectedVariant"
    :show-notify-me="$feature.showNotifyMeOnPDP"
    :show-only-first-selector-on-mobile="showOnlyFirstSelectorOnMobile"
    @open-size-guide="openSizeGuide"
    @select-color="selectColor"
    @select-size="selectSize"
  />
</template>

<script setup lang="ts">
defineProps<{ showOnlyFirstSelectorOnMobile?: boolean }>()

const {
  attributeSelection,
  attributeSelectionFormRef,
  attributeSelectionLabels,
  error,
  handleNextAttribute,
  inventory,
  isComingSoon,
  openSizeGuide,
  pending,
  product,
  selectColor,
  selectSize,
  selectedVariant
} = usePdp()
</script>
